export default __webpack_public_path__ + "static/media/epson-tmt88.0bbc2e31.png";